<a
  class="skip-link"
  href="#main-content"
  (click)="skipToMainContent($event)"
  (keydown.enter)="skipToMainContent($event)"
  (keydown.space)="skipToMainContent($event)"
>
  Skip to content
</a>
<div
  role="banner landmark"
  class="d-flex justify-content-between align-items-center header px-3 py-sm-3 py-2"
>
  <a
    class="col-3"
    href="#"
  >
    <span class="d-none">logo</span>
    <img
      class="img-fluid"
      src="../../../assets/icons/network_rail_logo.svg"
      alt="Network Rail logo"
    />
  </a>

  <div
    class="header-right d-flex justify-content-between ps-2"
    role="toolbar"
    aria-label="Header controls"
  >
    <div class="pe-3 pt-2 border-end">
      <div class="navbar navbar-expand-lg d-flex justify-content-end p-0">
        <div class="collapse navbar-collapse middle-icons show">
          <ul class="navbar-nav mr-auto d-flex justify-content-end flex-row gap-3">
            <li
              class="nav-item d-flex justify-content-end d-sm-block d-lg-block d-xl-block d-xxl-block"
            >
              <div class="d-flex gap-3 pb-1">
                <div class="icon-wrapper position-relative px-3">
                  <nr-icon
                    tabindex="0"
                    [name]="icons.CAT_IN_APP"
                    sizeClass="icon-size-32"
                    iconId="cat-in-app"
                    (click)="handleCATBadgeClick()"
                    (keydown.enter)="handleCATBadgeClick()"
                    (keydown.space)="handleCATBadgeClick()"
                    role="button"
                    aria-label="CAT In-App alerts"
                  ></nr-icon>

                  <div class="position-relative d-inline-block">
                    <button
                      class="notification-badge position-absolute border-0 d-flex align-items-center justify-content-center top-0 start-100 translate-middle badge bg-danger text-white px-2 py-1 small"
                      aria-label="CAT In-App alerts"
                      [attr.aria-describedby]="showTooltip ? 'catTooltip' : null"
                      [ngClass]="{ 'animate-pulse': shouldPulse }"
                      tabindex="-1"
                    >
                      {{ catInAppCount }}
                    </button>

                    <div
                      class="position-absolute bg-dark text-white rounded p-2 cat-in-app-tooltip cursor-pointer"
                      *ngIf="showTooltip"
                      (click)="navigateFromInAppTooltip()"
                      (keydown.enter)="navigateFromInAppTooltip()"
                      (keydown.space)="navigateFromInAppTooltip()"
                      role="tooltip"
                    >
                      <div class="tooltip-arrow position-absolute"></div>
                      <ul class="m-0 p-0 list-unstyled">
                        <li>
                          <span
                            class="rounded-circle bg-danger me-2 d-inline-block"
                            style="width: 6px; height: 6px"
                            tabindex="0"
                          ></span>
                          {{ tooltipText }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="ps-3 d-flex justify-content-end">
      <div class="user-login d-flex align-items-center gap-3">
        <div class="user-name navbar-expand-lg d-none d-sm-block">
          <span class="d-block">{{ user.name }}</span>
        </div>
        <button
          aria-label="User Profile"
          class="user-icon pe-0"
          name="User"
          aria-haspopup="true"
          [attr.aria-expanded]="showMenu"
          aria-controls="profileMenu"
          (click)="toggleMenu()"
          (keydown)="handleToggleKey($event)"
          type="button" 
          style="z-index: 2000; padding: 8px;"
        >
          <svg class="icon-size-l">
            <use xlink:href="../../../../assets/icons/svg-sprite.svg#icon-profile" />
          </svg>
        
        </button>
        <div
          class="profile-dropdown p-2"
          *ngIf="showMenu"
          (mouseleave)="showMenu = false"
          id="profileMenu"
          role="menu"
          tabindex="0"
          (keydown)="handleKeyNavigation($event)"
        >
          <div class="collapse navbar-collapse border-bottom pb-2 d-block d-sm-none">
            <span class="fw-bold text-end d-block">
              {{ user.name }}
            </span>
            <small>{{ user.designation }}</small>
          </div>

          <ul class="list-unstyled m-0 p-0">
            <li role="none">
              <button
                role="menuitem"
                class="text-decoration-underline btn btn-link profile-button p-0 w-100 text-start"
                aria-label="Profile page"
                (click)="myProfile()"
                tabindex="0"
              >
                Profile
              </button>
            </li>
            <li role="none">
              <button
                role="menuitem"
                class="text-decoration-underline btn btn-link profile-button p-0 w-100 text-start"
                aria-label="Logout"
                (click)="logout()"
                tabindex="0"
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
